import { Button, Heading, Picture, TextPassage } from '@petsmart-ui/sparky';
import Link from 'next/link';

import { getImageProps } from '../../../../utils/propsImagesItems';
import type { PromoCardProps } from '../types';
import './PromoCard.scss';

export function PromoCard({
    header,
    image,
    bodyText,
    cta,
    backgroundFill: background,
    handleAnalytics,
}: PromoCardProps) {
    const img = image && getImageProps(image);
    const Component = cta ? Link : 'div';

    return (
        <Component
            style={{ background }}
            className="c-promo-card"
            data-testid="promo-card"
            href={cta?.link.webUrl ?? ''}
            onClick={handleAnalytics}
            prefetch={false} // https://petsmart.atlassian.net/browse/HCP-594
        >
            {img && image && <Picture {...img} />}

            <div className="c-promo-card__content">
                <Heading tagName="h2">{header}</Heading>
                <TextPassage>{bodyText}</TextPassage>

                {cta && (
                    <Button
                        size="sm"
                        text={cta.text}
                        href={cta.link.webUrl}
                        variant={cta.buttonStyle === 'Primary' ? 'primary' : 'toolbar'}
                    />
                )}
            </div>
        </Component>
    );
}
